import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { addCuotaByAlumno } from "data/apiConection.js/dataCuotas";
import { useParams } from "react-router-dom";
import { dataAlumno } from "data/apiConection.js/dataAlumnos";
import { getUsers } from "data/apiConection.js/dataUsers";

const FormCuota = () => {
  const { id } = useParams();
  const [username, setUsername] = useState('');
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    usuario: " ",
    alumno_id: id,
    mes: "",
    monto: "",
    status: "",
    id_pagos_tic: "",
    metodo: ""
  });
  const [alumno, setAlumno] = useState({});

  useEffect(() => {
    const fetchUsers = async () => {
      const us = await getUsers();
      if (us) {
        setUsername(us.username);
        setFormData((prevData) => ({
          ...prevData,
          usuario: us.username // Actualiza el campo 'user' en formData
        }));
      }
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchAlumnoById = async (alumno_id) => {
      const al = await dataAlumno(alumno_id, '2025');
      setAlumno(al);
      setFormData((prevData) => ({
        ...prevData,
        monto: al.price_month // Actualiza el campo 'monto' en formData
      }));
    };
    fetchAlumnoById(formData.alumno_id);
  }, [formData.alumno_id]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value
    }));
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const body = {
        ...formData,
        monto: parseFloat(formData.monto) || 0, // Asegurar que el monto sea un número
        status: formData.status || "pendiente" // Valor por defecto para el estado
      };
      console.log(body);
      const response = await addCuotaByAlumno(body);
      if (response.message === "Cuota inserted successfully!") {
        // setFlagAddCuota(!flagAddCuota);
      }
    }
    setValidated(true);
  };

  return (
    <Card className="p-4">
      <Card.Body>
        <Card.Title className="mb-4">Formulario de Registro de Cuota</Card.Title>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="usuario">
              <Form.Label>Usuario</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Usuario"
                value={username}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, usuario.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="alumno_id">
              <Form.Label>ID del Alumno</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="ID del Alumno"
                value={alumno.firstName + ' ' + alumno.lastName}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el ID del alumno.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} md="6" controlId="mes">
              <Form.Label>Mes</Form.Label>
              <Form.Select
                required
                placeholder="Mes"
                value={formData.mes}
                onChange={handleInputChange}
              >
                <option value="">Seleccione Mes</option>
                <option value="Marzo">marzo</option>
                <option value="Abril">abril</option>
                <option value="Mayo">mayo</option>
                <option value="Junio">junio</option>
                <option value="Julio">julio</option>
                <option value="Agosto">agosto</option>
                <option value="Septiembre">septiembre</option>
                <option value="Octubre">octubre</option>
                <option value="Noviembre">noviembre</option>
                <option value="Diciembre">diciembre</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el mes.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="status">
              <Form.Label>Estado</Form.Label>
              <Form.Select
                required
                value={formData.status}
                onChange={handleInputChange}
              >
                <option value="">Seleccione un estado</option>
                <option value="pending">Pendiente</option>
                <option value="pagado">Pagado</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Por favor, seleccione un estado.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="monto">
              <Form.Label>Monto</Form.Label>
              <Form.Control
                required
                type="number"
                placeholder="Monto"
                value={formData.monto}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un monto válido.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="metodo">
              <Form.Label>Estado</Form.Label>
              <Form.Select
                required
                value={formData.metodo}
                onChange={handleInputChange}
              >
                <option value="">Seleccione un Metodo</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Transferencia">Transferencia</option>
                <option value="Debito">Debito</option>
                <option value="Credito">Credito</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Por favor, seleccione un estado.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="id_pagos_tic">
              <Form.Label>ID de Pagos TIC</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="ID de Pagos TIC"
                value={formData.id_pagos_tic}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese el ID de Pagos TIC.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="d-grid gap-2 mt-4">
            <Button type="submit" size="lg">
              Enviar Cuota
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

FormCuota.propTypes = {
  setFlagAddCuota: PropTypes.func,
  flagAddCuota: PropTypes.bool
};

export default FormCuota;